import React, {useContext, useEffect, useRef, useState} from 'react'
import t from 'helpers/I18n'


import PropTypes from 'prop-types'
import BaseParagraph from "../../base-components/base-paragraph";
import StepsLoader from "../steps-loader";
import StepFooterAction from "../../base-components/step-footer-action";
import InputField from "../../base-components/base-input";
import { useHistory } from 'react-router-dom';
import {AppDataContext} from 'contexts/app-data'


const DateOfBirthStep = ({_step_service, next_step, step_ID, step_URL, step_form, error, getDataFromContext, setDataToContext, getStep}) => {
    const [isValid, setIsValid] = useState(false)
    const form = useRef()
    const {state, dispatch} = useContext(AppDataContext)

    const history = useHistory();
    const data = getDataFromContext(step_ID)

    const [isLoading, setIsLoading] = useState(false)
    const [is18, setIs18] = useState(true)
    const [inputData, setInputData] = useState({ ...{"birthday" : data?.birthday.split("-").reverse().join('/')} })

    const mock_error = []

    const getInputValue = (name, value) => {
        if (value.length > 0) {
               setInputData({
            ...inputData,
            [name] : value
        })
        setDataToContext(step_ID, step_URL, name, value && value.split("/").reverse().join("-"))
        }
    }

    const endFlow = () => {
        dispatch({
            type: 'SET_END_FLOW_MESSAGE',
            end_flow:{
                title:t('exit_messages.impossible_body_title'),
                description: t('exit_messages.date_of_birth'),
                exit_statut: 2    
            }
        })

                     if (window.PageBus) {
                window.PageBus.publish("analyticsServices", {
eventType: "button click",
eventName: "age lower than 18",
trackMethod: "trackAction"
             }
            );
            }
        


        history.push('/steps/end-flow')
    }

    const _error = error.length > 0 || mock_error
    const action = () => {
        _step_service({step_ID, setIsLoading, next_step})
    }

    useEffect(() => {
        setIsValid(isValidForm())
    }, [inputData])

    useEffect(() => {
            if (window.PageBus) {
                window.PageBus.publish("analyticsServices", {
                    pageID: "onboarding",
                    stepSeq: "1",
                    stepName: "personal info:birth date",
                    flowType: "sales",
                    flowName: "onboarding",
                    productName: "onboarding",
                    trackMethod: "flow"
                }
                );
            }

            getStep(["birthday"]).then(res => {
                console.log(res)
                const savedDate = new Date(res.birthday)
                const now = new Date()
                if (`${now.getFullYear()}-${now.getMonth()}-${now.getDate()}` !== `${savedDate.getFullYear()}-${savedDate.getMonth()}-${savedDate.getDate()}`) {
                    setInputData({ ...{"birthday" : res?.birthday.split("-").reverse().join('/')} })
                }
            })
    }, [])

    const isValidForm = () => {

        const valToVlidate = inputData.birthday
        const dt = valToVlidate?.split("/")
        const validDate = new Date(new Date().getFullYear()-18, new Date().getMonth(), new Date().getDate())
        const inputDate = dt && new Date(dt[2], dt[1] - 1, dt[0])
        let max100Yers = new Date()
        max100Yers.setFullYear(max100Yers.getFullYear() - 100)
        max100Yers.setDate(max100Yers.getDate() - 1)

        setIs18(inputDate <= validDate)
            
        const validFeb = dt && Number(dt[1]) === 2 ? Number(dt[0]) <= 29 ? true : false : true 
        
        return [...form.current.elements].every(element => {
            return element.value !== "" && element.value !== " "
        }) && !valToVlidate.includes("_")
            && !dt[0].includes('_') && dt[0] < 32 && dt[0] > 0 &&
            !dt[1].includes('_') && dt[1] < 13 && dt[1] > 0 &&
            !dt[2].includes('_') && dt[2] < new Date().getFullYear() && dt[2] > 0 && validFeb && inputDate > max100Yers
    }

    return (
        <>
            <StepsLoader loading={isLoading}>
                <form ref={form}>
                    <BaseParagraph>
                        <h3>{t('personal_infos.Personal_info_birth_date.title')}</h3>
                    </BaseParagraph>

                    {step_form.map(input => (
                        <InputField
                            type={input.type}
                            label={t(input.label)}
                            value={inputData[input.id]}
                            name={input.id}
                            getInputValue={getInputValue}
                            key={input.id}
                            error={_error}
                        />))}
                </form>
                
            {is18 ? <StepFooterAction caption={t('general.continue')}  action={action} link={next_step} disabled={!isValid} /> : 
            <StepFooterAction caption={t('general.continue')}  action={endFlow} disabled={!isValid} />}
            </StepsLoader>

        </>
    )
}

DateOfBirthStep.propTypes = {
    error: PropTypes.array,
    _step_service: PropTypes.func,
    step_ID: PropTypes.string,
    step_URL: PropTypes.string,
    next_step: PropTypes.string,
    setDataToContext: PropTypes.any,
    getDataFromContext: PropTypes.any,
    step_form: PropTypes.array,
}


export default DateOfBirthStep